import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API() + 'raporty/'

export default {

    pobierzRaportBiletow(data) {
        return axios({
            method: 'post',
           url: URL+'pBiletyRap',
            data: JSON.stringify(data),
        })
    },

    pobierzRaportBiletowLinie(data) {
        return axios({
            method: 'post',
           url: URL+'pBiletyRap/linia',
            data: JSON.stringify(data),
        })
    },

    pobierzRaportBiletowMiesiecznych(data) {
        return axios({
            method: 'post',
           url: URL+'pBiletyMiesRap',
            data: JSON.stringify(data),
        })
    },

    pobierzRaportBiletowMiesiecznychNew(data) {
        return axios({
            method: 'post',
            url: URL+'pBiletyMiesRapNew',
            data: JSON.stringify(data),
        })
    },

    pobierzRaportBiletowMiesiecznychLinie(data) {
        return axios({
            method: 'post',
           url: URL+'pBiletyMiesRap/linia',
            data: JSON.stringify(data),
        })
    },

    pobierzSzczegoloweRozliczenieKursow(dataod,datado) {
        return axios({
            method: 'post',
           url: URL+'pRozliczKursowSzcz?dataOd='+dataod+'&dataDo='+datado,
        })
    },

    pobierzSzczegoloweRozliczenieKursowKierowcy(dataod,datado) {
        return axios({
            method: 'post',
           url: URL+'pRozliczKursowSzcz/kierowcy?dataOd='+dataod+'&dataDo='+datado,
        })

    },

    pobierzSzczegoloweRozliczenieKursowPojazdy(dataod,datado) {
        return axios({
            method: 'post',
           url: URL+'pRozliczKursowSzcz/pojazdy?dataOd='+dataod+'&dataDo='+datado,
        })
    },

    pobierzRozliczeniaKierowcowUtargi(params){
        return axios({
            method: 'get',
            url: URL+'kierowcy/szukaj'+params
        })
    },

    rozliczKursKierowcy(idKu){
        return axios({
            method: 'get',
            url: URL+'kierowcy/rozliczKurs/'+idKu
        })
    },

    rozliczWszystkieKursyKierowcy(dane){
        return axios({
            method: 'put',
            url: URL+`kierowcy/rozliczKursyGrupowo?dataOd=${dane.dataOd}&dataDo=${dane.dataDo}&idKi=${dane.idKi}`
        })
    },

    pobierzRaportZapelnienia(dataod,datado,idTr,idLi){
        return axios({
            method:'get',
            url:URL+'pBiletyRapOdbic?dataOd='+dataod+'&dataDo='+datado+'&idTr='+idTr+'&idLi='+idLi
        })
    }



}



// WEBPACK FOOTER //
// ./src/modules/raporty/RaportyService.js